import { http } from '../utils/http';
import Pagination from '../interfaces/common/pagination';
import Paging from '../interfaces/common/paging';
import SortFormatterUtils from '../utils/sortFormatterUtils';
import D365FeedbackStatus from '../interfaces/output/d365FeedbackStatus';

export default class D365FeedbackStatusApi {
    static fetchD365FeedbackStatusById = async(d365FeedbackStatusById: string): Promise<D365FeedbackStatus> => {
        const { data } = await http.get<D365FeedbackStatus>(`d365FeedbackStatus/${d365FeedbackStatusById}`);

        return data;
    };

    static fetchD365FeedbackStatuses = async(paging: Paging): Promise<Pagination<D365FeedbackStatus>> => {
        const url = SortFormatterUtils.addSortingToUrl(paging, null, '/d365FeedbackStatus');

        const { data } = await http.get<Pagination<D365FeedbackStatus>>(url);

        return data;
    };
}
